import ReportPage1 from "./report-page1";
export default ReportPage1;
